export const HEAVY_CHECK = '✔'
export const LIGHT_CHECK = '✓'
export const STAR = '★'
